import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ hideFrame?: boolean }>()(
  (theme, { hideFrame }) => ({
    setGroupsWrapper: {
      ...(hideFrame ? {} : theme.mixins.appContainer),
      padding: theme.spacing(1, 0, 0),

      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1, 0, 0),
      },
    },
    setGroupHeader: {
      width: '100%',
      padding: theme.spacing(1.5, 2),

      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1),
      },
    },
    setGroupExpandable: {},

    setNumberTitle: {
      ...theme.mixins.appEllipsis,
    },
    setGroupFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(1, 2),
      gap: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
    supersetDivider: {
      borderTop: `2px solid ${theme.palette.primary.main}`,
    },
  }),
);
